import React from "react";
import LOGO from "../../assets/logo/insightfulTraitsLogo.png";
import MOBILE_LOGO from "../../assets/logo/mobile-logo.png";
import { useTranslation } from "react-i18next";

const STEP_KEYS = ["status", "features", "payment", "done"];

const HeaderV2 = ({ currentStep = 1 }) => {
  const { t } = useTranslation();
  const steps = STEP_KEYS.map((key) => t(`header.${key}`));

  return (
    <div className="bg-white border-b border-[rgba(43,35,51,0.08)] sticky top-0 z-30">
      <div
        className="max-w-[1180px] mx-auto py-[14px] px-[clamp(16px,4vw,40px)]
          flex items-center justify-between gap-3 flex-nowrap
          max-[720px]:flex-wrap max-[720px]:gap-[10px]
          max-[375px]:flex-col max-[375px]:justify-center max-[375px]:gap-[10px]"
      >
        {/* Full logo — hidden below 580px */}
        <img
          src={LOGO}
          alt="InsightfulTraits"
          className="h-[30px] w-auto block max-[720px]:h-[26px] max-[580px]:hidden"
        />
        {/* Icon logo — shown below 580px */}
        <img
          src={MOBILE_LOGO}
          alt="InsightfulTraits"
          className="h-[30px] w-auto hidden max-[580px]:block max-[375px]:mx-auto"
        />

        {/* Steps */}
        <div
          className="flex items-center flex-nowrap gap-[clamp(7px,2vw,20px)]
            max-[720px]:flex-wrap max-[720px]:gap-x-[10px] max-[720px]:gap-y-[8px]
            max-[420px]:gap-[6px]
            max-[375px]:w-full max-[375px]:justify-center max-[375px]:gap-x-[12px] max-[375px]:gap-y-[8px]"
        >
          {steps.map((label, i) => {
            const done = i < currentStep;
            const cur = i === currentStep;
            return (
              <div
                key={STEP_KEYS[i]}
                className="flex items-center gap-2 max-[720px]:gap-[6px] max-[420px]:gap-[4px]"
              >
                <span
                  className={`w-[26px] h-[26px] max-[720px]:w-[22px] max-[720px]:h-[22px] max-[520px]:w-[20px] max-[520px]:h-[20px] max-[420px]:w-[18px] max-[420px]:h-[18px]
                    rounded-full flex-none flex items-center justify-center font-bold
                    text-[0.78rem] max-[520px]:text-[0.64rem] max-[420px]:text-[0.6rem]
                    ${
                      done
                        ? "bg-status-danger-bg text-brand-orange-hover"
                        : cur
                          ? "bg-transparent border-2 border-status-success-text text-status-success-text"
                          : "bg-transparent border-2 border-[rgba(43,35,51,0.16)] text-text-light"
                    }`}
                >
                  {done ? "✓" : i + 1}
                </span>
                <span
                  className={`font-bold whitespace-nowrap
                    text-[clamp(0.72rem,1.5vw,0.86rem)] max-[720px]:text-[0.7rem] max-[520px]:text-[0.64rem] max-[420px]:text-[0.58rem]
                    ${
                      done
                        ? "text-brand-orange-hover"
                        : cur
                          ? "text-status-success-text"
                          : "text-text-light"
                    }`}
                >
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HeaderV2;
